import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomInput from '../../../components/common/Input/input';
import SettingsBreadcrumb from '../../../components/SettingsBreadcrumb';
import './editar-cabecalho.scss'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
  Flex,
  Heading,
  Box,
  Button,
  FormLabel,
  FormControl,
  FormHelperText,
  Switch,
  Spinner,
  IconButton,
  Tooltip
} from '@chakra-ui/react';
import { ImageDropzoneSvg } from '../../../components/common/imageDropzoneSvg/imageDropzoneSvg';
import Swal from 'sweetalert2';
import logoCidadeinteligente from '../../../assets/svg/logo_cidadeinteligente.svg';
import * as api from '../../../api/cabecalho';
import { MdHelpOutline } from 'react-icons/md';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle, faSquare } from '@fortawesome/free-solid-svg-icons';
import { deletarCabecalhoImagem } from '../../../api/cabecalho';
import { isVideo, VIDEO_EXTENSIONS } from '../../../utils/media-analyzer';

const EditarCabecalho: React.FC = () => {
  const navigate = useNavigate();

  const [formValues, setFormValues] = useState<{
    imagem: { value: string; error: boolean };
    dscNomeInstituicao: { value: string; error: boolean };
  }>({
    imagem: { value: '', error: false },
    dscNomeInstituicao: { value: '', error: false },
  });

  const [logoInstituicao, setLogoInstituicao] = useState<any>();
  const [favIcon, setFavIcon] = useState<any>();
  const [seqUsuario, setSeqUsuario] = useState<any[]>([]);
  const [numRodape, setNumRodape] = useState(1);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingButton, setLoadingButton] = useState<boolean>(false);
  const [favIconPreview, setFavIconPreview] = useState<string>('');
  const [logoInstituicaoPreview, setLogoInstituicaoPreview] = useState<string>('');
  const [nomeCdnFavIcon, setNomeCdnFavIcon] = useState<any>(null);
  const [nomeCdnLogoInstituicao, setNomeCdnLogoInstituicao] = useState<any>(null);
  const [temImagemLogo, setTemImagemLogo] = useState<boolean>(false)
  const [temImagemFavIcon, setTemImagemFavIcon] = useState<boolean>(false)
  
  // Análise de tipo de mídia conforme padrão b6c108f
  const [logoMidiaInfo, setLogoMidiaInfo] = useState<{ tipo: 'image' | 'video' | null }>({ tipo: null });
  const [favIconMidiaInfo, setFavIconMidiaInfo] = useState<{ tipo: 'image' | 'video' | null }>({ tipo: null });

  useEffect(() => {
    const storedUsuario = localStorage.getItem('dadosUsuario');
    if (storedUsuario) {
      try {
        const usuario = JSON.parse(storedUsuario);
        setSeqUsuario(usuario.seqUsuario);
      } catch (error) {
        console.error("Erro ao recuperar os dados do usuário:", error);
      }
    }

    fetchCabecalhoData();
  }, []);

  const fetchCabecalhoData = async () => {
    setIsLoading(true);
    try {
      const cabecalhoData = await api.obterCabecalho();
      
      // Validar se há dados retornados antes de fazer destructuring
      if (!cabecalhoData || !Array.isArray(cabecalhoData) || cabecalhoData.length === 0) {
        console.warn("Nenhum dado de cabeçalho encontrado");
        setIsLoading(false);
        return;
      }
      
      const { dscInstituicao, imgLogo, imgFavicon, numRodapeLogo } = cabecalhoData[0];
  
      setFormValues((prev) => ({
        ...prev,
        dscNomeInstituicao: { value: dscInstituicao || '', error: false },
      }));
  
      if (imgFavicon && imgFavicon.trim() !== "") {
        setTemImagemFavIcon(true);
        setFavIcon(imgFavicon);
        setFavIconPreview(imgFavicon);
        // Análise de tipo de mídia: detecta se é vídeo ou imagem
        const isFavVideo = isVideo(imgFavicon);
        setFavIconMidiaInfo({ tipo: isFavVideo ? 'video' : 'image' });
        setFormValues((prev) => ({
          ...prev,
          favIcon: { value: imgFavicon, error: false },
        }));
        const delimiter = "%2F";
        const index = imgFavicon.lastIndexOf(delimiter);
        const finalFileName = index !== -1 ? imgFavicon.substring(index + delimiter.length) : imgFavicon;
        setNomeCdnFavIcon(finalFileName);
      } else {
        setTemImagemFavIcon(false);
        setFavIconMidiaInfo({ tipo: null });
      }
  
      if (imgLogo && imgLogo.trim() !== "") {
        setTemImagemLogo(true);
        setLogoInstituicao(imgLogo);
        setLogoInstituicaoPreview(imgLogo);
        // Análise de tipo de mídia: detecta se é vídeo ou imagem
        const isLogoVideo = isVideo(imgLogo);
        setLogoMidiaInfo({ tipo: isLogoVideo ? 'video' : 'image' });
        setFormValues((prev) => ({
          ...prev,
          logo: { value: imgLogo, error: false },
        }));
        const delimiter = "%2F";
        const index = imgLogo.lastIndexOf(delimiter);
        const finalFileName = index !== -1 ? imgLogo.substring(index + delimiter.length) : imgLogo;
        setNomeCdnLogoInstituicao(finalFileName);
      } else {
        setTemImagemLogo(false);
        setLogoMidiaInfo({ tipo: null });
      }
  
      setNumRodape(numRodapeLogo);
    } catch (error) {
      console.error("Erro ao buscar dados do cabecalho:", error);
    } finally {
      setIsLoading(false);
    }
  };  

  const handleFieldChange = (field: keyof typeof formValues, value: any) => {
    setFormValues({ ...formValues, [field]: { value, error: false } });
  };

  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleLogoInstituicaoSelected = async (selected: File | null) => {
    if (selected) {
      if (selected.type.startsWith("image/")) {
        setLogoInstituicao(selected);
        // Análise de tipo de mídia: detecta se é vídeo ou imagem
        const isLogoVideo = isVideo(selected.name);
        setLogoMidiaInfo({ tipo: isLogoVideo ? 'video' : 'image' });
        try {
          const base64Img = await convertFileToBase64(selected);
          setLogoInstituicaoPreview(base64Img);
        } catch (error) {
          console.error("Erro ao converter logo para Base64:", error);
        }
      } else {
        console.error("Tipo de arquivo não suportado.");
      }
    } else {
      setLogoInstituicao(null);
      setLogoInstituicaoPreview("");
      setLogoMidiaInfo({ tipo: null });
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const handleFavIconSelect = async (selected: File | null) => {
    if (selected) {
      if (selected.type.startsWith("image/")) {
        setFavIcon(selected);
        // Análise de tipo de mídia: detecta se é vídeo ou imagem
        const isFavVideo = isVideo(selected.name);
        setFavIconMidiaInfo({ tipo: isFavVideo ? 'video' : 'image' });
        try {
          const base64Fav = await convertFileToBase64(selected);
          setFavIconPreview(base64Fav);
        } catch (error) {
          console.error("Erro ao converter favicon para Base64:", error);
        }
      } else {
        console.error("Tipo de arquivo não suportado.");
      }
    } else {
      setFavIcon(null);
      setFavIconPreview("");
      setFavIconMidiaInfo({ tipo: null });
      console.warn("Nenhum arquivo selecionado.");
    }
  };

  const handleValidarLogoRodape = () => {
    setNumRodape((prev) => (prev === 1 ? 0 : 1));
  };

  const isFormValid = () => {
    const { dscNomeInstituicao } = formValues;
    const isNomeInstituicaoValido = dscNomeInstituicao.value.trim().length === 0 || dscNomeInstituicao.value.trim().length >= 5;
    return isNomeInstituicaoValido && logoInstituicao !== null;
  };

  const handleFormSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setLoadingButton(true);

    const { dscNomeInstituicao } = formValues;

    const params = {
      dscInstituicao: dscNomeInstituicao.value || null,
      numRodapeLogo: numRodape,
      imgLogo: typeof logoInstituicao === "string" ? logoInstituicao : '',
      imgFavIcon: typeof favIcon === "string" ? favIcon : '',
    };

    console.log('Params iniciais:', params);

    try {
      if (logoInstituicao) {
        if (logoInstituicao instanceof File) {
          const parts = logoInstituicao.name.split('.');
          const ext = parts.pop();
          const newFileExtension = ext ? ext.toLowerCase() : '';
  
          const fileNameLogo = `logoInstituicao.${newFileExtension}`;
          const formDataLogo = new FormData();
          formDataLogo.append("file", logoInstituicao);
          formDataLogo.append("fileName", fileNameLogo);
          formDataLogo.append("folderName", "cabecalho");
  
          if (temImagemLogo && nomeCdnLogoInstituicao) {
            await deletarCabecalhoImagem("cabecalho", nomeCdnLogoInstituicao);
          }
  
          const cdnLogoData = await api.inserirCabecalhoNoCdn(formDataLogo);
          console.log('Resposta do CDN para logo (tipo:', typeof cdnLogoData, '):', cdnLogoData);
  
          if (typeof cdnLogoData === "string") {
            const regex = /(https?:\/\/[^\s]+)/g;
            const match = cdnLogoData.match(regex);
            console.log('Match da regex para logo:', match);
            if (match && match[0]) {
              params.imgLogo = match[0];
            } else {
              console.error('Não foi possível extrair URL da resposta do CDN. Usando resposta completa.');
              params.imgLogo = cdnLogoData.trim();
            }
          } else if (cdnLogoData && cdnLogoData.url) {
            params.imgLogo = cdnLogoData.url;
          } else if (cdnLogoData) {
            console.warn('Formato inesperado do CDN, tentando serializar:', cdnLogoData);
            params.imgLogo = JSON.stringify(cdnLogoData);
          } else {
            console.error('Resposta do CDN vazia ou inválida');
            throw new Error("Resposta do CDN para o logo inesperada.");
          }
        } else {
          params.imgLogo = typeof logoInstituicao === "string" ? logoInstituicao : "";
        }
      } else {
        throw new Error("Logo obrigatório não foi selecionado.");
      }

      if (favIcon) {
        if (favIcon instanceof File) {
          const partsFav = favIcon.name.split('.');
          const extFav = partsFav.pop();
          const newFileExtensionFav = extFav ? extFav.toLowerCase() : '';
  
          const fileNameFav = `favicon.${newFileExtensionFav}`;
          const formDataFav = new FormData();
          formDataFav.append("file", favIcon);
          formDataFav.append("fileName", fileNameFav);
          formDataFav.append("folderName", "cabecalho");
  
          if (temImagemFavIcon && nomeCdnFavIcon) {
            await deletarCabecalhoImagem("cabecalho", nomeCdnFavIcon);
          }
  
          const cdnFavData = await api.inserirCabecalhoNoCdn(formDataFav);
          console.log('Resposta do CDN para favicon (tipo:', typeof cdnFavData, '):', cdnFavData);
  
          if (typeof cdnFavData === "string") {
            const regex = /(https?:\/\/[^\s]+)/g;
            const match = cdnFavData.match(regex);
            console.log('Match da regex para favicon:', match);
            if (match && match[0]) {
              params.imgFavIcon = match[0];
            } else {
              console.error('Não foi possível extrair URL da resposta do CDN. Usando resposta completa.');
              params.imgFavIcon = cdnFavData.trim();
            }
          } else if (cdnFavData && cdnFavData.url) {
            params.imgFavIcon = cdnFavData.url;
          } else if (cdnFavData) {
            console.warn('Formato inesperado do CDN, tentando serializar:', cdnFavData);
            params.imgFavIcon = JSON.stringify(cdnFavData);
          } else {
            console.error('Resposta do CDN vazia ou inválida');
            throw new Error("Resposta do CDN para o favicon inesperada.");
          }
        } else {
          params.imgFavIcon = typeof favIcon === "string" ? favIcon : "";
        }
      }

      console.log('Params antes de enviar para API:', params);
      const response = await api.editarCabecalho(params);
      console.log('Resposta da API editarCabecalho:', response);

      setLoadingButton(false);
      Swal.fire({
        icon: 'success',
        title: 'Sucesso!',
        text: 'Cabeçalho editado com sucesso.',
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/edicao-cidade-inteligente');
      });
    } catch (error: any) {
      console.error("Erro ao editar cabeçalho:", error);
      setLoadingButton(false);
      
      // Extrai a mensagem de erro estruturada do backend
      const errorMessage = error.message || 'Erro ao editar cabeçalho. Tente novamente mais tarde.';
      
      Swal.fire({
        icon: 'error',
        title: 'Ocorreu um erro!',
        text: errorMessage,
        confirmButtonColor: '#1789FC',
        confirmButtonText: 'OK',
      }).then(() => {
        navigate('/cms/edicao-cidade-inteligente');
      });
    }
  };  

  return (
    <Flex direction="column" padding='40px' background-color='#fafafa' width='100%' height='100%' overflow='hidden'>
      <SettingsBreadcrumb />
      <Heading mt="30px" fontWeight="600" fontSize="21px" color="#6F6F6F" w="100%">
        Edição de Cabeçalho
      </Heading>
      {isLoading ? (
        <Flex
          justify="center"
          align="center"
          direction="column"
          w="70%"
          h="90%"
          position='fixed'
        >
          <Spinner size="xl" color="blue.500" />
        </Flex>
      ) : (
        <Box m="40px 0" w="100%">
          <form onSubmit={handleFormSubmit}>
            <div className="row mb-3">
              <div className="col-md-6 mb-4">
                <FormControl>
                  <FormLabel mb="8px">FavIcon
                    <Tooltip
                      label="Um FavIcon é um pequeno ícone gráfico associado a um site. Ele é exibido na aba do navegador, na barra de favoritos e em outros locais, como na lista de histórico"
                      aria-label="Informação sobre o favIcon">
                      <IconButton
                        className='icones'
                        icon={<MdHelpOutline />}
                        variant="link"
                        aria-label="Informação"
                        size="md"
                        color={'#2883de'}
                      />
                    </Tooltip>
                  </FormLabel>
                  <ImageDropzoneSvg
                    base64={favIconPreview || favIcon}
                    onImageSelected={handleFavIconSelect}
                    uploadMessage="Arraste o favicon aqui ou clique para selecionar. (16x16 pixels)"
                    width={120}
                    height={100}
                  />

                  <input
                    id="image-upload"
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/png, image/x-icon"
                    onChange={(e) => handleFavIconSelect(e.target.files ? e.target.files[0] : null)}
                  />
                </FormControl>

                <FormControl mt={'24px'}>
                  <FormLabel mb="8px">Nome da Instituição</FormLabel>
                  <CustomInput
                    placeholder="Digite o nome da instituição"
                    value={formValues.dscNomeInstituicao.value}
                    onChange={(e) => handleFieldChange('dscNomeInstituicao', e.target.value)}
                    maxLength={100}
                    minLength={5}
                  />
                  {formValues.dscNomeInstituicao.value !== '' && formValues.dscNomeInstituicao.value.length < 5 && (
                    <FormHelperText color="red.500">
                      O nome da instituição precisa ter pelo menos 5 caracteres.
                    </FormHelperText>
                  )}
                  <FormHelperText color="gray.500">
                    Caso o nome da instituição já esteja na logo, não é necessário preenchê-lo aqui.
                  </FormHelperText>
                </FormControl>
              </div>


              <div className="col-md-6 mb-4">
                <FormControl isRequired>
                  <FormLabel mb="8px">Logo da Instituição</FormLabel>
                  <ImageDropzoneSvg
                    base64={logoInstituicaoPreview || logoInstituicao}
                    onImageSelected={handleLogoInstituicaoSelected}
                    uploadMessage="Arraste o logo aqui ou clique para selecionar. (PNG ou SVG)"
                    width={300}
                    height={100}
                  />

                  <input
                    id="image-upload"
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/jpeg, image/png"
                    onChange={(e) => handleLogoInstituicaoSelected(e.target.files ? e.target.files[0] : null)}
                  />
                </FormControl>
                <FormControl mt="24px">
                  <Flex align="center" gap="8px">
                    <FormLabel mb="0">Repetir o logo no rodapé</FormLabel>
                    {numRodape !== null && (
                      <Switch
                        colorScheme="blue"
                        isChecked={numRodape === 1}
                        onChange={handleValidarLogoRodape}
                      />
                    )}
                  </Flex>
                </FormControl>
              </div>

              <div className="col-md-12 mb-4">
                <FormControl>
                  <FormLabel mb="8px">Preview do Cabeçalho</FormLabel>
                </FormControl>
                <div className="top-header">
                  <div className="botao-acessibilidade" style={{ marginLeft: '8px' }}>
                    Alto constraste
                  </div>
                  <span style={{ marginLeft: '8px' }}>
                    |
                  </span>
                  <div className="botao-acessibilidade" style={{ marginLeft: '8px' }}>
                    <FontAwesomeIcon icon={faPlusCircle} color={'#6e6e6e'} />
                  </div>
                  <div className="botao-acessibilidade" style={{ marginLeft: '8px' }}>
                    <FontAwesomeIcon icon={faSquare} color={'#6e6e6e'} />
                  </div>
                  <div className="botao-acessibilidade" style={{ marginLeft: '8px' }}>
                    <FontAwesomeIcon icon={faMinusCircle} color={'#6e6e6e'} />
                  </div>
                </div>
                <div className="mid-header">
                  <div className="logo-title">
                    <a style={{ display: 'flex', backgroundColor: 'transparent' }}>
                      <img
                        key={logoInstituicaoPreview ? `image-${logoInstituicaoPreview}` : 'default-image'}
                        src={logoInstituicaoPreview || logoInstituicao}
                        className="logo-prefeitura"
                        style={{
                          marginTop: '-3px',
                          height: formValues.dscNomeInstituicao.value.trim().length === 0 ? '70px' : '50px',
                          width: formValues.dscNomeInstituicao.value.trim().length === 0 ? '350px' : '90px',
                          backgroundColor: 'transparent',
                          objectFit: 'contain',
                        }}
                      />
                    </a>
                    <p style={{ marginLeft: '10px', maxWidth: '400px', width: '400px' }}>
                      {formValues.dscNomeInstituicao.value.trim().length >= 1 ? formValues.dscNomeInstituicao.value : ''}
                    </p>
                  </div>

                  <div>
                    <img
                      src={logoCidadeinteligente}
                      className="img-radius"
                      alt="logo-plataforma"
                      style={{ height: '35px', width: '40vh', marginTop: '-3px' }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <Flex mt="35px" justifyContent="end">
              <Button m="6px" onClick={() => navigate('/cms/edicao-cidade-inteligente')}>
                Desistir
              </Button>
              <Button
                type="submit"
                m="6px"
                color="#FFF"
                bgColor="#1665D8"
                _hover={{ opacity: 0.8 }}
                isDisabled={!isFormValid()}
                isLoading={isLoadingButton}
                loadingText="Editando..."
              >
                Editar Cabeçalho
              </Button>
            </Flex>
          </form>
        </Box>
      )}
    </Flex>
  );
};

export default EditarCabecalho;
